import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { BaseDAO } from './baseDAO';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VesselRate } from 'anchor-shared/lib/model/entity/vessel-rate';
import { HttpHeaders } from '@angular/common/http';
import { WhatsIncluded } from 'anchor-shared/lib/model/interface/add-edit-vessel-rate-per-hour-dialog-data';
import { PayoutEstimationData } from 'anchor-shared/lib/model/interface/payout-estimation-data';

@Injectable()
export class VesselRateDAO extends BaseDAO<VesselRate> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.VESSEL_RATE);
  }

  public createWhatsIncludedRates(
    vesselId: number,
    whatsIncluded,
  ): Observable<VesselRate[]> {
    let url: string = `${this.apiHelper.getServiceName()}${this.getResource()}/whats-included/${vesselId}`;
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<VesselRate[]>(
      url,
      method,
      null,
      whatsIncluded,
      headers,
    );
  }

  public deleteFuelRate(vesselId: number): Observable<VesselRate[]> {
    let url: string = `${this.apiHelper.getServiceName()}${this.getResource()}/delete-fuel-rate/${vesselId}`;
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<VesselRate[]>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  public applyTaxToRates(
    vesselId: number,
    updates: WhatsIncluded,
  ): Observable<VesselRate[]> {
    let url: string = `${this.apiHelper.getServiceName()}${this.getResource()}/apply-tax-to-rates/${vesselId}`;
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<VesselRate[]>(
      url,
      method,
      null,
      updates,
      headers,
    );
  }

  public addRemoveCleaning(
    vesselId: number,
    updates: WhatsIncluded,
  ): Observable<VesselRate[]> {
    let url: string = `${this.apiHelper.getServiceName()}${this.getResource()}/add-remove-cleaning/${vesselId}`;
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<VesselRate[]>(
      url,
      method,
      null,
      updates,
      headers,
    );
  }

  public vesselPayoutEstimation(
    vesselId: number,
    charterDuration: number,
  ): Observable<PayoutEstimationData[]> {
    let url: string = `${this.apiHelper.getServiceName()}${this.getResource()}/vessel-pay-out-estimation/${vesselId}/${charterDuration}`;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<PayoutEstimationData[]>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  public getByVesselId(vesselId: number): Observable<VesselRate[]> {
    let url: string = `${this.apiHelper.getServiceName()}${this.getResource()}/vessel/${vesselId}`;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<VesselRate[]>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  public loadForVessel(vesselId: number): Observable<VesselRate[]> {
    let url: string = `${this.apiHelper.getServiceName()}${this.getResource()}/vessel/${vesselId}`;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<VesselRate[]>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  getProductAdjustedRates(
    vesselId: number,
    date: string,
    duration: number,
  ): Observable<{ charterBaseFee: number; vesselRates: VesselRate[] }> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/get-product-adjusted-rates/vessel/' +
      `${vesselId}/date/${date}/duration/${duration}`;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<{
      charterBaseFee: number;
      vesselRates: VesselRate[];
    }>(url, method, null, null, headers);
  }

  getOriginalPriceBeforeDiscount(
    vesselId: number,
    duration: number,
  ): Observable<string> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/get-price-before-discount/vessel/' +
      `${vesselId}/duration/${duration}`;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = null;
    return this.apiHelper.apiCall<any>(url, method, null, data, headers);
  }

  public calculateVesselRate(
    rate: VesselRate,
    duration: number,
  ): Observable<{ rateAmount: number }> {
    let url: string = `${this.apiHelper.getServiceName()}${this.getResource()}/calculate-vessel-rate`;
    const body = {
      rate,
      duration,
    };
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<{ rateAmount: number }>(
      url,
      method,
      null,
      body,
      headers,
    );
  }

  public calculateUpdatedVesselRate(
    rates: VesselRate[],
  ): Observable<VesselRate[]> {
    let url: string = `${this.apiHelper.getServiceName()}${this.getResource()}/calculate-updated-vessel-rates`;
    const body = {
      rates,
    };

    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<VesselRate[]>(
      url,
      method,
      null,
      body,
      headers,
    );
  }
}
